import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Quizzes } from '../../../redux/quiz/types'
import { appConfig } from '../../../appConfig'

type Props = {
  text?: string
  quiz?: Quizzes
  additionalTokens?: Record<string, any>
}
export const ContextAwareText: React.FC<Props> = ({ text, quiz, additionalTokens }) => {
  const values = useContextAwareValues(quiz, additionalTokens)

  if (!text) {
    return null
  }

  // @ts-expect-error — Misaligned typings: the rich-text tags are functions
  return <FormattedMessage id={text} defaultMessage={text} values={values} />
}

// The tokens and rich-text tags ContextAwareText supports, for callers that need
// the formatted nodes themselves (e.g. to type them out).
export const useContextAwareValues = (quiz?: Quizzes, additionalTokens?: Record<string, any>) => {
  const intl = useIntl()

  return {
    br: <br />,
    hr: <hr />,
    b: (chunks: React.ReactNode) => <b>{chunks}</b>,
    i: (chunks: React.ReactNode) => <i>{chunks}</i>,
    green: (chunks: React.ReactNode) => <span style={{ color: '#085F5F' }}>{chunks}</span>,
    privacyPolicy: (
      <a href={`${appConfig.zoeWebsiteBaseUri}/privacy-policy`} style={{ color: 'var(--colour-text-link)' }}>
        Privacy Policy
      </a>
    ),
    gender: quiz?.gender
      ? intl
          .formatMessage({
            id: `quiz.gender.${quiz.gender}.display_plural`,
          })
          .toLowerCase()
      : '',
    ageRange: quiz?.age_range
      ? intl.formatMessage({
          id: `quiz.age_range.${quiz.age_range}`,
        })
      : '',
    ...additionalTokens,
  }
}
